import React, { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [showAlert, setShowAlert] = useState(false); // State to manage alert visibility

  // Event handler for form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission

    // Firebase Realtime Database URL
    const databaseUrl = "https://fir-data-feed-default-rtdb.firebaseio.com/"; // Replace with your Firebase project ID

    // Construct the URL to submit the form data to
    const submitUrl = `${databaseUrl}Contactformportfolio.json`; // Adjust the path as needed

    // Make a POST request to submit the form data
    fetch(submitUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to submit data");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Data submitted successfully:", data);
        // Clear the form fields after successful submission
        setFormData({
          name: "",
          email: "",
          message: "",
        });
        // Show the alert message
        setShowAlert(true);
        // Hide the alert message after 2 seconds
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Error:", error);
        // Show error message to the user
        alert("Failed to submit form. Please try again.");
      });
  };

  // Event handler to update form data state
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div>
      <div className="container-fluid contact">
        <div className="row">
          <div className="col-sm-4">
            <h1 className="head"> Let's build something amazing together!</h1>
            <h5 className="my-2">
              Any Questions? Connect through social media.
            </h5>
            <br />
            <br />
            <h5>Email :</h5>
            <a className="iconf" href="mailto:ianshulgora+web@gmail.com">
              ianshulgora@gmail.com
            </a>
            <br />
            <br />
            <h5>Say Hello :</h5>
            <a href="https://instagram.com/ianshulgora" target="blank">
              <i className="fab iconf fa-instagram fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://www.linkedin.com/in/anshul-gora" target="blank">
              <i className="fab iconf fa-linkedin-in fa-2x fa-beat"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://twitter.com/ianshulgora" target="blank">
              <i className="fab iconf fa-x-twitter fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://github.com/anshulgora" target="blank">
              <i className="fab iconf fa-github fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <br />
            <br />
            <br />
            <br />
          </div>
          <div className="col-md-8 col-sm-8">
            <h3 className="contacthead">Contact form :</h3>
            {showAlert && (
              <div className="my-3" role="alert">
                <h5 className="hoverclass">
                  Shukriya, contact krne ke liye !!
                </h5>
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label for="exampleInputPassword1" className="form-label">
                  Message
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="3"
                />
              </div>
              <button type="submit" className="btn btnadd">
                Submit <i class="ri-send-plane-line"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
